export default "__VITE_ASSET__DJ5kkCgX__"